@if(loading$ | async) {
<app-loading
  class="h-100 w-100 loading-container"
  [text]="'Loading'"
></app-loading>
} @else {
<div class="container-fluid d-flex flex-column">
  <div class="button-list" *ngIf="addButtonText!==''">
    <button
      class="release-btn btn-accello-secondary"
      (click)="addNewTestSuite()"
    >
      <img
        [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
        alt="Add Icon"
        width="18"
        height="18"
      />
      {{ addButtonText }}
    </button>

    <button
      class="release-btn btn-accello-light"
      (click)="removeTestSuites()"
      [disabled]="isDisabled"
      (focus)="changeRemoveIcon(false)"
      (mouseenter)="changeRemoveIcon(false)"
      (mouseleave)="changeRemoveIcon(false)"
      (blur)="changeRemoveIcon(false)"
      (mousedown)="changeRemoveIcon(true)"
      (mouseup)="changeRemoveIcon(false)"
    >
      <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
      {{ removeButtonText }}
    </button>
    <button class="btn-accello-ternary" (click)="refreshData()">
      <img [src]="'images/virtusa-icons/sync.svg' | assetUrl" alt="refresh" />
      <span>Refresh</span>
    </button>
  </div>

  @if(dataStore.activeNode?.type === 'script_group' && folders?.length) {
  <div class="d-flex mb-4 flex-column">
    <div class="header-wrapper">
      <span class="accello-general-text14">Test Suite</span>
    </div>
    <div class="custom-card">
      <app-script-card-tile
        class="w-100"
        [cardList]="folders"
        (selectedCardsChange)="handleSelectedCards($event)"
        (onEditClick)="onEditSuite($event)"
      ></app-script-card-tile>
    </div>
  </div>
  }
  <div class="d-flex flex-column">
    

    @if(this.isSuite){
      <div class="d-flex flex-row">
        <div class="page-tab d-flex gap-3">
          <div class="name-div"><span class="accello-general-text2 pg-sp">Test Suite Name</span>
            <span class="accello-general-text13">{{
              selectedSuite?.name
            }}</span></div>
        </div>
      </div>
    } @else{
      <div class="header-wrapper">
        <span class="accello-general-text14">Test Script</span>
      </div>
    }
    <div class="reusable-wrapper">
      <app-zorro-table
        tableId="sts"
        [data]="scripts"
        [columns]="columns"
        [options]="{ expandable: true }"
        (onRowSelect)="handleRowSelect($event)"
        (handleActions)="handleTableActions($event)"
      ></app-zorro-table>
    </div>
  </div>
</div>
}
